export default __webpack_public_path__ + "static/media/about_us-150x150.ffa143b2.png";